<template>
	<nk-box
		v-if="context && context.showForId === context.kontaktperson.id"
		variant="sidebar"
	>
		<div class="space-y-4">
			<nk-title v-if="context.title" size="lg">
				{{ context.title }}
			</nk-title>
			<div v-if="context.text" class="nk-cms-content" v-html="context.text" />
			<nk-button v-if="context.link" expand :link="context.link">
				{{ context.linktext || 'Weitere Informationen' }}
			</nk-button>
		</div>
	</nk-box>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {object} context
 * @prop {string} context.title
 * @prop {string} context.text
 * @prop {string} context.link
 * @prop {string} context.linktext
 * @prop {number} context.showForId
 * @prop {object} context.kontaktperson
 */
export default {
	name: 'NkSidebarSprechzeiten',

	mixins: [TemplatesDefault],
};
</script>
